import React from "react";
import { motion } from "framer-motion";
import TypingText from "../utils/TypingText";
import resources from "../../resources/Content";

export default function CompanyInfo() {
  const { companyInfo } = resources.about;

  return (
<section
  className="relative bg-[#0e1b26] text-white px-6 md:px-20 pt-32 pb-20 text-center overflow-hidden"
>

  {/* Background Mountain Image  */}
  <div
    className="absolute inset-0 bg-cover bg-center opacity-30"
    style={{
      backgroundImage: `url('/assets/images/backgrounds/mountain-dark.jpg')`,
      filter: "blur(6px)",
    }}
  />

  {/* Gradient */}
  <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/70"></div>

  {/* Spotlight */}
  <div className="absolute top-1/2 left-1/2 w-[900px] h-[900px] -translate-x-1/2 -translate-y-1/2 bg-white/5 rounded-full blur-3xl"></div>

  {/* Watermark */}
  <h1
    className="absolute left-1/2 -translate-x-1/2 font-black text-white/10 tracking-tight leading-none pointer-events-none select-none"
    style={{
      fontSize: "clamp(3rem, 16vw, 15rem)",
      top: "clamp(2.5rem, 2.1vw, 2.5rem)",
    }}
  >
    {companyInfo.watermarkTop}
  </h1>

  <h1
    className="absolute left-1/2 -translate-x-1/2 font-black text-white/10 tracking-tight leading-none pointer-events-none select-none"
    style={{
      fontSize: "clamp(0.6rem, 13vw, 13rem)",
      top: "calc(clamp(3rem, 2.1vw, 2.5rem) + 0.9em)"
    }}
  >
    {companyInfo.watermarkBottom}
  </h1>

  {/* Logo */}
  <motion.img
    src={companyInfo.logo}
    className="relative z-20 w-36 md:w-56 mx-auto"
    initial={{ scale: 0, rotate: -180, opacity: 0 }}
    whileInView={{ scale: 1, rotate: 0, opacity: 1 }}
    transition={{ duration: 1.2 }}
  />

 {/* Text */}
<div className="relative z-20 max-w-4xl mx-auto space-y-6 mt-10 text-center">
  <p className="font-light px-3 py-11 text-[#d0d0d0] text-[20px] leading-relaxed">
    <TypingText
      speed={0.01}
      text={companyInfo.description}
    />
  </p>
</div>

</section>
  );
}